import { useEffect, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { LoggedInAppArgs } from "../App";
import { DataScape, SignalRResponse } from "../Data/ScapeData";
import ScapeGameView from "./ScapeGameView";
import styles from './ScapeView.module.scss';
import AddPlayerModal, { admin } from "./AddPlayerModal";
import InvitationLinkView from "./InvitationLinkView";


interface ScapeViewArgs {

}

const ScapeView: React.FC<ScapeViewArgs> = args => {
    const parentContext = useOutletContext() as LoggedInAppArgs;
    const params = useParams();
    const nav = useNavigate();
    const [scape, setScape] = useState<DataScape | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const [isLoading, setIsLoading] = useState(false);
    const scapeId = params['scapeId'];

    useEffect(() => {
        if (!scapeId) {
            setErrorMessage("Failed to find game id in parameters.");
        }
    }, [scapeId])

    const addMemberHandler = async (userId: string) => {
        setIsLoading(true);
        console.log("Set is loading");
        try {
            const token = await parentContext.loggedInUser.getAccessToken();

            const addPlayerResponse = await fetch(`/api/v1.0/scapes/${scape.id}/addWatcher`, {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                    "Authorization": `Bearer ${token}`, // if using JWT auth,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ UserId: userId })
            });

            if (!addPlayerResponse.ok) {
                throw new Error(`HTTP error ${addPlayerResponse.status}`);
            }
            const response = await addPlayerResponse.json();
            setScape(prev => { return { ...prev, members: response.members } });
        } catch (e) {
            var err: Error = e;
            setErrorMessage(e.Message);
            console.log("There was an error.");
        }
        setIsLoading(false);
        parentContext.setModalContent(null);
    }

    const getScapeSignalR = async (): Promise<DataScape> => {
        if (!parentContext.scapeConnection) {
            console.log("Missing Scape Connection");
            return;
        }
        console.log("Getting scape list.");
        setIsLoading(true);
        // args.setModalContent(null);
        try {
            const temp: SignalRResponse<DataScape> = await parentContext.scapeConnection.invoke('Get', { Id: scapeId });
            console.log(`Got scapes`);
            console.log(temp);
            // setScapes(temp.data.items);
            setIsLoading(false);
            return temp.data;
        } catch (e) {
            const err = e as Error;
            console.log(e);
            setIsLoading(false);
            throw e;
        }
    }

    const getScapeREST = async (): Promise<DataScape> => {
        setIsLoading(true);
        const token = await parentContext.loggedInUser.getAccessToken();

        const response = await fetch(`/api/v1.0/scapes/${scapeId}`, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}` // if using JWT auth
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error ${response.status}`);
        }
        setIsLoading(false);
        return await response.json(); // return parsed data
    }

    const deleteScape = async (): Promise<void> => {
        setIsLoading(true);
        const token = await parentContext.loggedInUser.getAccessToken();

        const response = await fetch(`/api/v1.0/scapes/${scapeId}?deepDelete=1`, {
            method: "DELETE",
            headers: {
                "Accept": "application/json",
                "Authorization": `Bearer ${token}` // if using JWT auth
            }
        });

        if (!response.ok) {
            setErrorMessage(`HTTP error ${response.status}`)
            setIsLoading(false);
            parentContext.setModalContent(null);
            return;
        }
        nav("/");
        parentContext.setModalContent(null);
    }

    useEffect(() => {
        getScapeSignalR()
            .then((result) => {
                console.log(result);
                setScape(result);
            })
            .catch(e => {
                setErrorMessage(`Error getting scape: ${e.Message}`);
                console.log(`Error getting scape: ${e.Message}`);
            })
    }, [parentContext.scapeConnection]);

    if (isLoading) {
        return <div>Loading...</div>
    }

    if (
        !scape ||
        errorMessage
    ) {
        return <div>There was a fatal error: {errorMessage ?? "unknown"}</div>
    }

    return <div className={styles.scapeView}>
        <div className={styles.scapeInfo}>
            <h1>Scape: {scape.name}</h1>
            <p>Id: {scape.id}</p>
            {scape.creator.id === parentContext.loggedInUser.userId && <InvitationLinkView
                scapeConnection={parentContext.scapeConnection}
                scapeId={scape.id}
                gameId={scape.currentGameId}
            />}
            <div>
                <button
                    className={styles.deleteButton}
                    onClick={async e => {
                        parentContext.setModalContent({
                            element: <div>
                                <h1>Are you sure?</h1>
                                <p>Do you really want to delete this scape?</p>
                                <button
                                    className={styles.deleteButton}
                                    onClick={e => {
                                        deleteScape();
                                    }}
                                >Yes, delete scape</button>
                                <button
                                    onClick={e => parentContext.setModalContent(null)}
                                >
                                    No, do not delete
                                </button>
                            </div>,
                            canClose: true
                        })
                    }}
                >Delete</button>
            </div>
            <h3>Owner:</h3>
            <p>{scape.creator.username}</p>
            <p>{scape.creator.id}</p>
            <img src={scape.creator.avatar.smallUrl} />
            <h3>Members</h3>
            <button
                onClick={e => {
                    parentContext.setModalContent({
                        element: <AddPlayerModal addPlayer={addMemberHandler} showBot={false} />,
                        canClose: true
                    });
                }}
            >Add Member</button>
            <ul>
                {scape.members.map(m => {
                    var user = admin.find(u => u.id === m.userId);
                    return <li>
                        {m.userId} : {user ? user.name : "unknown name"}
                    </li>
                })}
            </ul>
        </div>

        {scape.currentGameId ? <ScapeGameView
            gameId={scape.currentGameId}
            loggedInUser={parentContext.loggedInUser}
            setModalContent={parentContext.setModalContent}
            scapeConnection={parentContext.scapeConnection}
        /> : <p>This scape does not have a game</p>}

    </div>
}

export default ScapeView;